import { f as r } from "./function-call.js";
import { i as o } from "./is-object.js";
import { i } from "./is-symbol.js";
import { g as t } from "./get-method.js";
import { o as m } from "./ordinary-to-primitive.js";
import { w as e } from "./well-known-symbol.js";
var s = TypeError,
  a = e("toPrimitive"),
  f = function f(e, _f) {
    if (!o(e) || i(e)) return e;
    var n,
      p = t(e, a);
    if (p) {
      if (void 0 === _f && (_f = "default"), !o(n = r(p, e, _f)) || i(n)) return n;
      throw s("Can't convert object to primitive value");
    }
    return void 0 === _f && (_f = "number"), m(e, _f);
  };
export { f as t };